type CreateMilestoneError = {
  emptyName: boolean;
  duplicateName: boolean;
  endDateOutOfBound: boolean;
  listNotFound: boolean;
};

const createMilestoneError: CreateMilestoneError = {
  emptyName: false,
  duplicateName: false,
  endDateOutOfBound: false,
  listNotFound: false,
};

export type { CreateMilestoneError };

export { createMilestoneError };
